/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcQuotemediaV1Sp500ListState } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_QUOTEMEDIA_V1_SP500_LIST_STATE_ENTITY_NAME = 'exc.quotemedia.v1.Sp_500List';
export const excQuotemediaV1Sp500ListStateEntity = new schema.Entity<ExcQuotemediaV1Sp500ListState>(EXC_QUOTEMEDIA_V1_SP500_LIST_STATE_ENTITY_NAME, {}, { idAttribute: 'quarter' });

